import React from "react";

const ProgressBar = ({ steps, activeStep, completedStep }) => {
  return (
    <div className="flex items-center justify-center space-x-2 lg:space-x-4">
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          {/* Step */}
          <div className="flex flex-col items-center">
            <div
              className={`rounded-full h-[34px] w-[34px] flex items-center justify-center ${
                index + 1 <= completedStep
                  ? "bg-blue-shades text-white" // Completed steps with checkmark
                  : activeStep === index + 1
                  ? "bg-blue-shades text-white" // Active step
                  : "bg-soft-gray text-gray" // Incomplete steps
              }`}
            >
              {index + 1 <= completedStep ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="white"
                  className="w-5 h-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              ) : (
                index + 1
              )}
            </div>
            <span className="text-gray font-inter leading-[16px] tracking-[0.5px] text-[10px] mt-1 hidden sm:block">
              {step.fullLabel}
            </span>
            <span className="text-gray font-inter leading-[16px] tracking-[0.5px] text-[10px] mt-1 block sm:hidden">
              {step.shortLabel}
            </span>
          </div>

          {/* Progress Line */}
          {index < steps.length - 1 && (
            <div className="flex items-center w-8 sm:w-16 lg:w-20">
              <div className="w-full h-[6px] bg-soft-gray rounded-[40px]">
                <div
                  className="h-[6px] rounded-[40px] bg-blue-shades"
                  style={{
                    width:
                      activeStep > index + 1
                        ? "100%"
                        : activeStep === index + 1
                        ? "50%"
                        : "0%",
                  }}
                ></div>
              </div>
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default ProgressBar;
